import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  urgentTotal:'',
  secondaryTotal:'',
  ordinaryTotal:'',
  totals:'',
  priority: '',
  unreadTotal: '',
  getUnFinishTotal: '',
}

const mutations = {
  getPriorityTotal(state, obj){
    let token = cookie.getCookie('token');
    http.post(window.config.api.baseUrl + '/eims-api/toDoList/priorityTotal', {
      token: token,
      data: {}
    }).then(response => {
      if (response.data.code == '00000'){
        let responseData = response.data.data;
        state.urgentTotal = responseData.urgentTotal;
        state.secondaryTotal = responseData.secondaryTotal;
        state.ordinaryTotal = responseData.ordinaryTotal;

        state.totals = Number(state.urgentTotal ? state.urgentTotal : 0) +
                       Number(state.secondaryTotal ? state.secondaryTotal : 0) +
                       Number(state.ordinaryTotal ? state.ordinaryTotal : 0);
      }
    })
  },

  getUnreadTotal(state, obj){
    let token = cookie.getCookie('token');
    http.post(window.config.api.baseUrl + '/eims-api/toDoList/toDoTotal', {
      token: token,
      data: {}
    }).then(response => {
      if (response.data.code == '00000'){
        let responseData = response.data.data;

        state.unreadTotal = responseData.unreadTotal;
        state.getUnFinishTotal = responseData.getUnFinishTotal;
      }
    })
  },

  preservePriority(state, obj){
    state.priority = obj;
  }
}

const actions = {
  getPriorityTotal:({commit, state}, obj) => commit("getPriorityTotal", obj),
  getUnreadTotal:({commit, state}, obj) => commit("getUnreadTotal", obj),
  preservePriority:({commit, state}, obj) => commit("preservePriority", obj),
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pendingItemListModule.js